<div class="{{ className }}">
  <div class="{{ className }}__header">
    <modal-icon-title-chip-close
      (emitActions)="close()"
      [close]="true"
      [title]="'Your fist deployment in minutes'"></modal-icon-title-chip-close>
  </div>
  <mat-dialog-content class="{{ className }}__modal-body">
    <p class="{{ className }}__text">
      Pick any application from the marketplace and deploy it on a real node. Auto-onboarding walks
      you through every step — no setup, no prior knowledge needed.
    </p>
    <div class="{{ className }}__video-container">
      <video autoplay loop width="100%">
        <source src="assets/videos/demo_onboarding_video_mobile.mp4" type="video/mp4" />
        Your browser does not support video playback.
      </video>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="{{ className }}__modal-footer">
    <button (click)="close()" class="big" color="primary" mat-button>Skip</button>
    <button
      (click)="openOnboarding()"
      class="big {{ className }}__button-onboarding"
      color="accent"
      mat-button
      mat-flat-button>
      Start auto-onboarding
    </button>
  </mat-dialog-actions>
</div>